import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaCounter from './VaCounter.vue'

export const VaCounter = withConfigTransport(_VaCounter)
